export enum UserType {
  Provider = 'provider',
  Member = 'member',
  Guest = 'guest',
}

export type MemberIdentity = Partial<{
  schedule_id: number;
  member_id: number;
  auth_token: string;
}>;
